import { HttpInterceptorFn } from '@angular/common/http';
import { StorageHelper } from '@helpers/storage.helper';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = StorageHelper.getToken()?.accessToken;
  // Don’t add to non-API requests or if there’s already an Authorization header
  if (!token || req.headers.has('Authorization')) {
    return next(req);
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return next(authReq);
};
